// removed by extract-text-webpack-plugin
module.exports = {"xsmall":"only screen and (min-width: 375px)","small":"only screen and (min-width: 481px)","medium":"only screen and (min-width: 768px)","large":"only screen and (min-width: 993px)","xlarge":"only screen and (min-width: 1201px)","headerWrapper":"headerWrapper-1Mdw2","header":"header-268H-","headerNavToggle":"headerNavToggle-3A00V","headerLogo":"headerLogo-DQzhm","active":"active-LsnHA","headerTagline":"headerTagline-2S5Ym","headerLinks":"headerLinks-3gggD","authLinks":"authLinks-lM49d","socialLinks":"socialLinks-2HtUC","accent":"accent-2_qr-","progress":"progress-to7hl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/yearInReview/2017/Header/_header.css
// module id = 1292
// module chunks = 1